function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import Common from "../components/includes/Common";
import moment from "moment";
import { DatePicker, Space, Table, message, Button, Divider, Form } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import { Excel } from "antd-table-saveas-excel";
import { Download, Cash, BuildingFill, BuildingFillGear, PeopleFill, CalculatorFill } from "react-bootstrap-icons";
import CompanyBills from "../components/CompanyBills";
import InsBills from "../components/InsBills";
import Moment from "react-moment";
import UserBills from "../components/UserBills";
import dayjs from 'dayjs';
import { CSVLink } from "react-csv";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;

var Accounting = function Accounting() {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      listOfBills = _useState2[0],
      setListOfBills = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      billsArrayData = _useState4[0],
      setBillsArrayData = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      isDataLoading = _useState6[0],
      setIsDataLoading = _useState6[1];

  var _useState7 = useState(moment().startOf('day').format()),
      _useState8 = _slicedToArray(_useState7, 2),
      from = _useState8[0],
      setFrom = _useState8[1];

  var _useState9 = useState(moment().endOf('day').format()),
      _useState10 = _slicedToArray(_useState9, 2),
      to = _useState10[0],
      setTo = _useState10[1];

  var rangePresets = {
    "Aujourdh'ui": [moment().startOf('day'), moment().endOf('day')],
    'Cette semaine': [moment().startOf('week'), moment().endOf('week')],
    'Ce mois': [moment().startOf('month'), moment().endOf('month')]
  };
  var cols = [{
    title: "JOURNAL",
    dataIndex: "JOURNAL",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "JOURNAL"
  }, {
    title: "DATE PIECE",
    dataIndex: "DATE_PIECE",
    render: function render(date) {
      return /*#__PURE__*/_jsx("span", {
        children: moment(date).format("DDMMYY")
      });
    },
    key: "DATE_PIECE"
  }, {
    title: "COMPTE",
    dataIndex: "COMPTE",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "COMPTE"
  }, {
    title: "SECTION",
    dataIndex: "SECTION",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "SECTION"
  }, {
    title: "LIBELLE",
    dataIndex: "LIBELLE",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "LIBELLE"
  }, {
    title: "SENS",
    dataIndex: "SENS",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "SENS"
  }, {
    title: "MONTANT",
    dataIndex: "MONTANT",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "MONTANT"
  }, {
    title: "REFERENCE",
    dataIndex: "REFERENCE",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "REFERENCE"
  }, {
    title: "MODE",
    dataIndex: "MODE",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "MODE"
  }];

  var handleExport = function handleExport() {
    var excel = new Excel();
    excel.addSheet("sheet").addColumns(cols).addDataSource(billsArrayData, {
      str2Percent: true
    }).saveAs(from + "-" + to + ".xlsx");
  };

  var onSearchFinish = function onSearchFinish(values) {
    setListOfBills([]);
    setBillsArrayData([]);
    setFrom(moment(new Date(values.range[0]._d)).format());
    setTo(moment(new Date(values.range[1]._d)).format());
  };

  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + "getbills/" + moment(new Date(from)).format() + "/" + moment(new Date(to)).format() + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setListOfBills(response.data.bills);
        response.data.bills.forEach(function (e) {
          var iar = [];
          e.bill_items.forEach(function (i) {
            if (i.medical_item != null) iar.push(i.medical_item.label);
          });
          setBillsArrayData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: "v_in" + e.id,
              JOURNAL: "VENTE",
              REFERENCE: "FCT-CL" + e.id,
              DATE_PIECE: e.created_at,
              COMPTE: e.company_id == null ? "41" + e.customer.firstname.replace(/\s/g, '') + e.customer.lastname.replace(/\s/g, '') : "41" + e.company.label.replace(/\s/g, ''),
              SECTION: e.bill_items[0].medical_item.department.dcode,
              LIBELLE: iar.join(", "),
              SENS: "D",
              MONTANT: e.total_amount.toLocaleString("Fr"),
              MODE: e.company_part > 0 ? "CONVENTIONE" : "PARTICULIER"
            }]);
          });
          setBillsArrayData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: "v_out" + e.id,
              JOURNAL: "VENTE",
              REFERENCE: "FCT-CL" + e.id,
              DATE_PIECE: e.created_at,
              COMPTE: "70600000",
              SECTION: e.bill_items[0].medical_item.department.dcode,
              LIBELLE: iar.join(", "),
              SENS: "C",
              MONTANT: e.total_amount.toLocaleString("Fr"),
              MODE: e.company_part > 0 ? "CONVENTIONE" : "PARTICULIER"
            }]);
          });
          setBillsArrayData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: "c_in" + e.id,
              JOURNAL: "CAISSE",
              REFERENCE: "FCT-CL" + e.id,
              DATE_PIECE: e.created_at,
              COMPTE: e.company_id == null ? "41" + e.customer.firstname.replace(/\s/g, '') + e.customer.lastname.replace(/\s/g, '') : "41" + e.company.label.replace(/\s/g, ''),
              SECTION: e.bill_items[0].medical_item.department.dcode,
              LIBELLE: iar.join(", "),
              SENS: "D",
              MONTANT: e.total_amount.toLocaleString("Fr"),
              MODE: e.company_part > 0 ? "CONVENTIONE" : "PARTICULIER"
            }]);
          });
          setBillsArrayData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: "c_out" + e.id,
              JOURNAL: "CAISSE",
              REFERENCE: "FCT-CL" + e.id,
              DATE_PIECE: e.created_at,
              COMPTE: "57100000",
              SECTION: e.bill_items[0].medical_item.department.dcode,
              LIBELLE: iar.join(", "),
              SENS: "C",
              MONTANT: e.total_amount.toLocaleString("Fr"),
              MODE: e.company_part > 0 ? "CONVENTIONE" : "PARTICULIER"
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [from, to]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: [/*#__PURE__*/_jsx(Form, {
            size: "large",
            onFinish: onSearchFinish,
            layout: "horizontal",
            children: /*#__PURE__*/_jsxs(Space, {
              direction: "horizontal",
              children: [/*#__PURE__*/_jsx(Form.Item, {
                name: "range",
                rules: [{
                  required: true,
                  message: "Champs obligatoire"
                }],
                children: /*#__PURE__*/_jsx(RangePicker, {
                  ranges: rangePresets,
                  showTime: {
                    format: 'HH:mm'
                  },
                  format: "DD-MM-YYYY HH:mm"
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  htmlType: "submit",
                  children: /*#__PURE__*/_jsx("b", {
                    children: "RECHERCHE"
                  })
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  onClick: handleExport,
                  style: {
                    background: "#34C482"
                  },
                  icon: /*#__PURE__*/_jsx(Download, {
                    size: 28
                  }),
                  children: /*#__PURE__*/_jsx("b", {
                    children: "EXPORTER"
                  })
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(CSVLink, {
                  filename: "Expense_Table.csv",
                  data: billsArrayData,
                  className: "btn btn-primary",
                  children: "Exporter en CSV"
                })
              })]
            })
          }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs("div", {
            style: {
              fontWeight: "bold",
              fontStyle: 'italic'
            },
            children: ["Du ", new Date(from).toLocaleDateString("Fr"), " Au ", new Date(to).toLocaleDateString("Fr")]
          }), /*#__PURE__*/_jsx(Table, {
            size: "xs",
            columns: cols,
            bordered: true,
            sticky: true,
            loading: isDataLoading,
            dataSource: billsArrayData
          })]
        })
      })
    })
  });
};

export default Accounting;